
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface LenderFiltersProps {
  searchTerm: string;
  riskLevel: string;
  onSearchChange: (value: string) => void;
  onRiskLevelChange: (value: string) => void;
}

const LenderFilters = ({
  searchTerm,
  riskLevel,
  onSearchChange,
  onRiskLevelChange,
}: LenderFiltersProps) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 mb-6">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Search lenders..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10"
        />
      </div>
      <Select value={riskLevel} onValueChange={onRiskLevelChange}>
        <SelectTrigger className="w-full md:w-[200px]">
          <SelectValue placeholder="Risk Level" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Risk Levels</SelectItem>
          <SelectItem value="conservative">Conservative</SelectItem>
          <SelectItem value="moderate">Moderate</SelectItem>
          <SelectItem value="aggressive">Aggressive</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default LenderFilters;
